import { GetSpaceBase } from '../../types/GetSpaceBase';
import { getUndefinedSpace } from '../../utils/getUndefinedSpace';
import { spaceFactory } from '../../utils/spaceFactory';

export const getSpaceGeneral: GetSpaceBase = (
  group,
  space,
) => {
  switch (group) {
    case 'NEG_OPTION_TERMS': {
      switch (space) {
        case 'title': {
          return spaceFactory('newPaymentTerms_title').get();
        }
        default: break;
      }
      break;
    }
    case 'ID_VALIDATION_WELCOME': {
      switch (space) {
        case 'title': return spaceFactory('ID_VALIDATION_WELCOME.title').get();
        default: break;
      }
      break;
    }
    default: break;
  }

  return getUndefinedSpace(true); // if not found here, error
};
